"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var CheckoutForm_1 = __importDefault(require("../../Components/CheckoutForm"));
var reconnect_js_1 = require("reconnect.js");
function CheckoutInfoPage() {
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  return react_1.default.createElement(Wrapper, null, react_1.default.createElement(antd_1.Card, null, react_1.default.createElement(antd_1.PageHeader, {
    title: "\u8FD4\u56DE",
    onBack: function () {
      return AppActions.navigate('/checkout');
    },
    style: {
      padding: 0
    }
  }), react_1.default.createElement(CheckoutForm_1.default, null)));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n"])));
exports.default = CheckoutInfoPage;
var templateObject_1;